import React, { useEffect, useState } from 'react';
import { Container, Button, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaSearch, FaBlender, FaTruck, FaHandshake, FaGlobeAmericas } from 'react-icons/fa';
import './Home.css';

function Home() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const styles = {
    heroSection: {
      background: 'linear-gradient(135deg, rgba(15, 23, 42, 0.95) 0%, rgba(30, 41, 59, 0.9) 50%, rgba(71, 85, 105, 0.85) 100%), url("https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=1600&q=80") center/cover',
      padding: '140px 0 100px',
      position: 'relative',
      overflow: 'hidden',
      minHeight: '100vh'
    },
    heroOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'radial-gradient(ellipse at top right, rgba(251, 146, 60, 0.15) 0%, transparent 50%), radial-gradient(ellipse at bottom left, rgba(59, 130, 246, 0.15) 0%, transparent 50%)',
      pointerEvents: 'none'
    },
    minVh75: {
      minHeight: '75vh',
      position: 'relative',
      zIndex: 2
    },
    heroText: {
      paddingRight: '40px'
    },
    heroTitle: {
      fontSize: '3.5rem',
      fontWeight: 800,
      color: '#ffffff',
      lineHeight: 1.15,
      marginBottom: '24px',
      textShadow: '0 4px 12px rgba(0,0,0,0.3)',
      letterSpacing: '-0.02em'
    },
    heroDescription: {
      fontSize: '1.15rem',
      color: '#e2e8f0',
      lineHeight: 1.7,
      marginBottom: '32px',
      opacity: 0.95,
      maxWidth: '560px'
    },
    heroButtons: {
      display: 'flex',
      gap: '16px',
      flexWrap: 'wrap',
      marginBottom: '40px'
    },
    btnPrimary: {
      padding: '16px 40px',
      fontSize: '1.05rem',
      fontWeight: 700,
      borderRadius: '8px',
      backgroundColor: '#fb923c',
      borderColor: '#fb923c',
      color: '#ffffff',
      transition: 'all 0.3s ease',
      boxShadow: '0 4px 15px rgba(251, 146, 60, 0.4)',
      border: 'none',
      textTransform: 'uppercase',
      letterSpacing: '0.5px'
    },
    btnOutline: {
      padding: '16px 40px',
      fontSize: '1.05rem',
      fontWeight: 700,
      borderRadius: '8px',
      color: '#ffffff',
      borderColor: '#ffffff',
      backgroundColor: 'transparent',
      transition: 'all 0.3s ease',
      border: '2px solid #ffffff',
      textTransform: 'uppercase',
      letterSpacing: '0.5px'
    },
    heroStats: {
      display: 'flex',
      gap: '40px',
      marginTop: '48px',
      paddingTop: '32px',
      borderTop: '1px solid rgba(255,255,255,0.2)'
    },
    statItem: {
      textAlign: 'left'
    },
    statNumber: {
      fontSize: '2rem',
      fontWeight: 800,
      color: '#fb923c',
      marginBottom: '4px',
      display: 'block'
    },
    statLabel: {
      fontSize: '0.85rem',
      color: '#cbd5e1',
      textTransform: 'uppercase',
      letterSpacing: '1px',
      fontWeight: 600
    },
    heroImageCol: {
      position: 'relative',
      height: '500px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    astronautContainer: {
      position: 'relative',
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    mainAstronaut: {
      position: 'relative',
      width: '450px',
      height: '450px',
      backgroundImage: 'url("/images/manami.png")',
      backgroundSize: 'contain',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      filter: 'drop-shadow(0 20px 40px rgba(0,0,0,0.5))',
      zIndex: 3
    },
    floatingElement1: {
      position: 'absolute',
      top: '10%',
      right: '5%',
      width: '80px',
      height: '80px',
      background: 'linear-gradient(135deg, #fb923c 0%, #f97316 100%)',
      borderRadius: '50%',
      boxShadow: '0 8px 32px rgba(251, 146, 60, 0.4)',
      animation: 'float 6s ease-in-out infinite',
      zIndex: 2
    },
    floatingElement2: {
      position: 'absolute',
      bottom: '15%',
      right: '10%',
      width: '60px',
      height: '60px',
      background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
      borderRadius: '50%',
      boxShadow: '0 8px 32px rgba(59, 130, 246, 0.4)',
      animation: 'float 8s ease-in-out infinite 2s',
      zIndex: 2
    },
    floatingElement3: {
      position: 'absolute',
      top: '30%',
      left: '0%',
      width: '40px',
      height: '40px',
      background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
      borderRadius: '50%',
      boxShadow: '0 8px 32px rgba(251, 191, 36, 0.4)',
      animation: 'float 7s ease-in-out infinite 1s',
      zIndex: 2
    },
    geometricShape1: {
      position: 'absolute',
      top: '5%',
      left: '10%',
      width: '120px',
      height: '120px',
      border: '3px solid rgba(251, 146, 60, 0.3)',
      borderRadius: '20px',
      transform: 'rotate(25deg)',
      animation: 'rotate 20s linear infinite',
      zIndex: 1
    },
    geometricShape2: {
      position: 'absolute',
      bottom: '10%',
      left: '5%',
      width: '0',
      height: '0',
      borderLeft: '60px solid transparent',
      borderRight: '60px solid transparent',
      borderBottom: '104px solid rgba(59, 130, 246, 0.2)',
      transform: 'rotate(15deg)',
      animation: 'rotate 15s linear infinite reverse',
      zIndex: 1
    },
    dataVisualization: {
      position: 'absolute',
      top: '15%',
      right: '10%',
      padding: '16px 20px',
      background: 'rgba(15, 23, 42, 0.8)',
      backdropFilter: 'blur(10px)',
      borderRadius: '12px',
      border: '1px solid rgba(251, 146, 60, 0.3)',
      zIndex: 4,
      minWidth: '140px'
    },
    dataTitle: {
      fontSize: '0.7rem',
      color: '#94a3b8',
      textTransform: 'uppercase',
      letterSpacing: '1px',
      marginBottom: '8px',
      fontWeight: 600
    },
    dataValue: {
      fontSize: '1.5rem',
      color: '#fb923c',
      fontWeight: 800,
      marginBottom: '4px'
    },
    dataSubtext: {
      fontSize: '0.75rem',
      color: '#cbd5e1'
    },
    featuresSection: {
      padding: '100px 0',
      position: 'relative',
      backgroundImage: 'linear-gradient(rgba(248, 250, 252, 0.95), rgba(248, 250, 252, 0.95)), url("https://images.unsplash.com/photo-1542838132-92c53300491e?w=1600&q=80")',
      backgroundSize: 'cover',
      backgroundAttachment: 'fixed',
      backgroundPosition: 'center'
    },
    sectionTitle: {
      fontSize: '2.75rem',
      fontWeight: 800,
      color: '#0f172a',
      marginBottom: '16px',
      letterSpacing: '-0.02em'
    },
    sectionSubtitle: {
      fontSize: '1.15rem',
      color: '#64748b',
      marginBottom: '60px',
      maxWidth: '600px',
      margin: '0 auto 60px'
    },
    featureCard: {
      border: 'none',
      borderRadius: '12px',
      padding: '24px',
      height: '100%',
      transition: 'all 0.3s ease',
      background: 'white',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
      position: 'relative',
      overflow: 'hidden'
    },
    featureIcon: {
      fontSize: '2.5rem',
      marginBottom: '16px',
      color: '#0f172a',
      display: 'block'
    },
    featureCardTitle: {
      fontSize: '1.15rem',
      fontWeight: 700,
      color: '#0f172a',
      marginBottom: '12px',
      letterSpacing: '-0.01em'
    },
    featureCardText: {
      color: '#64748b',
      lineHeight: 1.6,
      fontSize: '0.95rem'
    },
    ctaSection: {
      padding: '80px 0',
      position: 'relative',
      overflow: 'hidden',
      backgroundImage: 'linear-gradient(rgba(15, 23, 42, 0.92), rgba(30, 41, 59, 0.92)), url("https://images.unsplash.com/photo-1557804506-669a67965ba0?w=1600&q=80")',
      backgroundSize: 'cover',
      backgroundAttachment: 'fixed',
      backgroundPosition: 'center',
      color: 'white'
    },
    ctaOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'radial-gradient(ellipse at center, rgba(251, 146, 60, 0.1) 0%, transparent 70%)',
      pointerEvents: 'none'
    },
    ctaContent: {
      position: 'relative',
      zIndex: 2
    },
    ctaTitle: {
      fontSize: '2.5rem',
      fontWeight: 800,
      marginBottom: '16px',
      letterSpacing: '-0.02em',
      textShadow: '0 2px 10px rgba(0,0,0,0.3)'
    },
    ctaText: {
      fontSize: '1.15rem',
      opacity: 0.95,
      lineHeight: 1.6,
      textShadow: '0 1px 5px rgba(0,0,0,0.2)'
    },
    btnCtaLight: {
      backgroundColor: '#fb923c',
      color: 'white',
      border: 'none',
      padding: '16px 40px',
      fontWeight: 700,
      borderRadius: '8px',
      transition: 'all 0.3s ease',
      boxShadow: '0 4px 15px rgba(251, 146, 60, 0.4)',
      textTransform: 'uppercase',
      letterSpacing: '0.5px'
    }
  };

  return (
    <>
      {/* Hero Section */}
      <div style={styles.heroSection}>
        <div style={styles.heroOverlay}></div>
        <Container>
          <Row className="align-items-center" style={styles.minVh75}>
            <Col lg={6} className="order-2 order-lg-1 hero-text-animate" style={styles.heroText}>
              <h1 style={styles.heroTitle}>
                Reliable Trade. Quality Products. Trusted Partnerships.
              </h1>
              <p style={styles.heroDescription}>
                We are a Namibia-based trading company focused on sourcing and supplying high-quality products while building reliable, long-term partnerships across local and regional markets.
              </p>
              <div style={styles.heroButtons}>
                <Button as={Link} to="/contact" style={styles.btnPrimary} className="btn-primary-hero">
                  Contact Us
                </Button>
                <Button as={Link} to="/products" style={styles.btnOutline} className="btn-outline-hero">
                  Our Products
                </Button>
              </div>
            </Col>
            <Col lg={6} className="order-1 order-lg-2 hero-shapes-animate" style={styles.heroImageCol}>
              <div style={styles.astronautContainer}>
                <div style={styles.mainAstronaut}></div>
                <div style={styles.floatingElement1}></div>
                <div style={styles.floatingElement2}></div>
                <div style={styles.floatingElement3}></div>
                <div style={styles.geometricShape1}></div>
                <div style={styles.geometricShape2}></div>
                <div style={styles.dataVisualization}>
                  <div style={styles.dataTitle}>Quality Products</div>
                  <div style={styles.dataValue}>1.24K</div>
                  <div style={styles.dataSubtext}>Sourced & supplied</div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Features Section */}
      <section style={{...styles.featuresSection, backgroundPositionY: `${scrollY * 0.5}px`}}>
        <Container>
          <h2 className="text-center" style={styles.sectionTitle}>Our Services</h2>
          <p className="text-center" style={styles.sectionSubtitle}>
            Comprehensive trading solutions tailored to your business needs
          </p>
          <Row className="g-3 justify-content-center">
            <Col sm={6} md={4} className="service-card-slide">
              <Card style={styles.featureCard} className="service-card-hover">
                <Card.Body>
                  <FaSearch style={styles.featureIcon} />
                  <Card.Title style={styles.featureCardTitle}>Product Sourcing & Procurement</Card.Title>
                  <Card.Text style={styles.featureCardText}>
                    Expert sourcing and procurement services to find the right products for your business needs.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} md={4} className="service-card-slide">
              <Card style={styles.featureCard} className="service-card-hover">
                <Card.Body>
                  <FaBlender style={styles.featureIcon} />
                  <Card.Title style={styles.featureCardTitle}>Dehydrating & Blending</Card.Title>
                  <Card.Text style={styles.featureCardText}>
                    Custom dehydrating and blending of fruits & veggies to your required texture, flavor and grain size.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} md={4} className="service-card-slide">
              <Card style={styles.featureCard} className="service-card-hover">
                <Card.Body>
                  <FaTruck style={styles.featureIcon} />
                  <Card.Title style={styles.featureCardTitle}>Wholesale & Distribution</Card.Title>
                  <Card.Text style={styles.featureCardText}>
                    Reliable wholesale and distribution services to get products where they need to be.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} md={4} className="service-card-slide">
              <Card style={styles.featureCard} className="service-card-hover">
                <Card.Body>
                  <FaHandshake style={styles.featureIcon} />
                  <Card.Title style={styles.featureCardTitle}>Supplier Coordination</Card.Title>
                  <Card.Text style={styles.featureCardText}>
                    Seamless coordination with suppliers to ensure smooth operations and timely delivery.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} md={4} className="service-card-slide">
              <Card style={styles.featureCard} className="service-card-hover">
                <Card.Body>
                  <FaGlobeAmericas style={styles.featureIcon} />
                  <Card.Title style={styles.featureCardTitle}>Market Linkage & Trade Facilitation</Card.Title>
                  <Card.Text style={styles.featureCardText}>
                    Connecting businesses to markets and facilitating trade opportunities across regions.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CTA Section */}
      <section style={{...styles.ctaSection, backgroundPositionY: `${scrollY * 0.3}px`}}>
        <div style={styles.ctaOverlay}></div>
        <Container style={styles.ctaContent}>
          <Row className="align-items-center">
            <Col lg={8}>
              <h2 style={styles.ctaTitle}>Ready to Start Trading?</h2>
              <p style={styles.ctaText}>Partner with Manami Trading for reliable sourcing and quality products across Namibia and beyond.</p>
            </Col>
            <Col lg={4} className="text-lg-end">
              <Button as={Link} to="/contact" style={styles.btnCtaLight} className="btn-cta-hover">
                Contact Us Today
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Home;